// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs[data-v-23e1efae] .v-tabs-slider-wrapper{display:block!important}@media screen and (max-width:600px){.list-content[data-v-23e1efae]{padding:0 4px!important}}", ""]);
// Exports
module.exports = exports;
